export const TOAST_MESSAGES = {
    ESS_FETCH_FAILED: "Failed to Fetch ESS Data",
    ESS_UPLOADED: " Document Uploaded ",
    ESS_UPLOAD_FAILED: "Failed to Upload ESS",
    USER_FETCH_FAILED: "Failed to Fetch User",
    SUCCESS_DELETE_ESS: "Document Deleted",
    FAILED_DELETE_ESS: "Failed to Delete Document",
    ERROR_DELETE_ESS: "Error to Delete Document",
    FAILED_FETCH_REFERRALS: "Failed to Fetch Referrals",
    ADD_REFERRAL: "Referral Submitted Successfully",
    FAILED_ADD_REFERRAL: "Failed to Submit Referral",
    FAILED_TO_FETCH_REFERRAL: "Failed to Fetch Referral",
    NO_RESPONSE_DATA: "Referrals Not Available",
    FAILED_TO_UPDATE: "Failed to Update Referral",
    DELETE_REFERRAL: "Referral Deleted Successfully",
    FAILED_TO_DELETE_REFERRAL: "Failed to Delete Referral",
}

export const EMP_DOC_COLUMNS = [
    "username",
    "file_name",
    "description",
    "file",
    "action",
];

export const EMP_DOC_LABELS = {
    username: "Employee Name",
    file_name: "File Name",
    description: "Description",
    file: "File",
    action: "Action"
}

export const REFERRAL_COLUMNS = [
    "referred_by_full_name",
    "referred_person_name",
    "referred_position",
    "mobile_number",
    "status",
    "is_declaration_signed",
    "actions",
];

export const REFERRAL_COLUMNS_LABELS = {
    referred_by_full_name: "Referred By",
    referred_person_name: "Referred Person",
    referred_position: "Referred Position",
    mobile_number: "Mobile Number",
    status: "Status",
    is_declaration_signed: "Declaration Signed",
    actions: "Actions",
};

export const REFERRAL_STATUS = [
    {label: "Referred", value: "REFERRED"},
    {label: "Interview In Progress", value: "INTERVIEW_IN_PROGRESS"},
    {label: "Selected", value: "SELECTED"},
    {label: "Rejected", value: "REJECTED"},
    {label: "Pending Disbursement", value: "PENDING_DISBURSEMENT"},
    {label: "Disbursed", value: "DISBURSED"},
]

export const REFERRAL_STATUS_LABELS = {
  REFERRED: "REFERRED",
  INTERVIEW_IN_PROGRESS: "INTERVIEW_IN_PROGRESS",
  SELECTED: "SELECTED",
  REJECTED: "REJECTED",
  PENDING_DISBURSEMENT: "PENDING_DISBURSEMENT",
  DISBURSED: "DISBURSED",
};

export const REFERRAL_ACTION_MODE = {
    ADD: "add",
    VIEW: "view",
    EDIT: "edit"
}

export const REFERRAL_VALIDATION_MESSAGES = {
  referred_person_name: "Referred Person Name is Required",
  referred_position: "Referred Position is Required",
  mobile_number: "Contact Number is Required",
  email: "Email is Required",
  is_declaration_signed: "Declaration is Required",
  resume: "Resume is Required",
};

export const DECLARATION_VALUES = [
    {label: "Yes", value: "true"},
    {label: "No", value: "false"},
]

export const REFERRAL_STATUS_COLORS = {
  REFERRED: "bg-blue-100 text-blue-700",
  INTERVIEW_IN_PROGRESS: "bg-yellow-100 text-yellow-700",
  SELECTED: "bg-green-100 text-green-700",
  REJECTED: "bg-red-100 text-red-700",
  PENDING_DISBURSEMENT: "bg-purple-100 text-purple-700",
  DISBURSED: "bg-emerald-100 text-emerald-700",
};
